<template>
    <div>
        <b-modal id="modal_form"
                 ref="modal_form"
                 :title="modal_titulo"
                 :ok-title="modal_botao"
                 close-title="Fechar"
                 v-model="showModal"
                 :ok-disabled=form.errors.any()
                 @ok="onGerar">

                 <span v-if="!certificado_instalado">
                    <b-alert variant="warning" show>Atenção, não há certificado A1 configurado para emissão do CTE. Favor configurar na tela de configurações da conta </b-alert>
                 </span>
                 <div class="loadingDataPosition">
                     <div class="loadingData" v-if="loadingDataModelo"><div class="loadingDataSpinner"><spinner v-if="loadingDataModelo" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                     <div class="col-md-12 col-sm-12 gerar-cte-modal-modelo">
                         <label>Modelo </label>
                         <multiselect v-model="form.modelo_cte"
                         :options="optionsModelo"
                         track-by="value"
                         label="label"
                         :hide-selected="true"
                         placeholder="Selecione"
                         tag-placeholder="Selecionar"
                         select-label="Selecionar"
                         selected-label="Selecionado"
                         deselect-label="Remover"
                         ></multiselect>
                         <b-form-feedback v-text="form.errors.get('modelo_cte.value')" v-if="form.errors.has('modelo_cte.value')"></b-form-feedback>
                         <small> A utilização de um modelo é opcional</small>
                     </div>
                 </div>
                 <div class="row bs-glyphicons">
                    <div class="col-md-12"><label>Selecione o Modal do CTE</label></div>
                    <div class="col-md-4 text-center">
                        <a href='#' @click="onGerar($event, 3)">
                            <div class="alert alert-blue-dirty alert-fill m-a">
                                <i class="fa fa-2x fa-ship" aria-hidden="true"></i> <br/>Aquaviário
                            </div>
                        </a>
                    </div>

                    <div class="col-md-4 text-center">
                        <a href='#' @click="onGerar($event, 1)">
                            <div class="alert alert-blue-dirty alert-fill m-a">
                                <i class="fa fa-2x fa-truck" aria-hidden="true"></i> <br/>Rodoviário
                            </div>
                        </a>
                    </div>

                    <div style="pointer-events:none;opacity:0.2" class="col-md-4 text-center">
                        <a  href='#' @click="onGerar($event, 2)">
                            <div class="alert alert-blue-dirty alert-fill m-a">
                                <i class="fa fa-2x fa-plane" aria-hidden="true"></i> <br/>Aéreo
                            </div>
                        </a>
                    </div>

                    <div class="col-md-4 text-center m-t-md">
                        <a href='#' @click="onGerar($event, 6)">
                            <div class="alert alert-blue-dirty alert-fill m-a">
                                <i class="fa fa-2x fa-tasks" aria-hidden="true"></i> <br/>Multimodal
                            </div>
                        </a>
                    </div>

                    <div style="pointer-events:none;opacity:0.2" class="col-md-4 text-center m-t-md">
                        <a href='#' @click="onGerar($event, 4)">
                            <div class="alert alert-blue-dirty alert-fill m-a">
                                <i class="fa fa-2x fa-train" aria-hidden="true"></i> <br/>Ferroviário
                            </div>
                        </a>
                    </div>

                    <div style="pointer-events:none;opacity:0.2" class="col-md-4 text-center m-t-md">
                        <a href='#' @click="onGerar($event, 5)">
                            <div class="alert alert-blue-dirty alert-fill m-a">
                                <i class="fa fa-2x fa-minus" aria-hidden="true"></i> <br/>Dutoviário
                            </div>
                        </a>
                    </div>

                 </div>

             <div slot="modal-footer" class="w-100">
                    <div class="float-right">
                        <b-btn @click="showModal=false" variant="secondary">
                          Fechar
                        </b-btn>
                    </div>
             </div>
        </b-modal>
        <GerarCteForm
            ref="gerarcteform">
        </GerarCteForm>
    </div>
</template>
<script>
import GerarCteForm from './GerarCteForm'
export default {
components: {
    GerarCteForm,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingDataModelo: true,
      showModal: false,
      optionsModelo: [],
      form: new Form({modelo_cte: []}),
     helpForm: new Form({statusRecord: [], params: [], search: ''}),
    fields: [
      {
          name: '__checkbox',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      },
      {
        name: 'cd',
        title: 'Código',
        sortField: 'cd'
      },
      {
        name: 'descr',
        title: 'Descrição',
        sortField: 'descr'
      },
      {
        name: '__slot:status',
        title: 'Status',
        sortField: 'status'
      },
      {
          name: '__slot:actions',   // <----
          title: 'Ações',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      }
  ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
methods: {
    onCreate ()
    {
      this.isDisabled = false;
      this.loading = false;
      this.loadingDataModelo = true;
      this.modal_titulo = "Selecionar modal";
      this.modal_botao = "Continuar";
      this.modal_acao = "i";
      this.form.reset();
      this.optionsModelo = null;
      this.optionsModelo = [];
      this.$refs.gerarcteform.optionsModelo.forEach((obj)=>
      {
          this.optionsModelo.push({ label: obj.label, value: obj.value , mod: obj.mod})
      })
      this.loadingDataModelo = false;
      this.$refs.modal_form.show();
    },
    onGerar(e, modal){
        this.$refs.gerarcteform.onGerarCte(e, modal);
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    },
    certificado_instalado: {
        get() {
            return this.$store.getters.certificado_instalado;
        }
    },
}
}
</script>
